export enum TRACKING_EVENT_NAMES {
    loggedInHeroProductCtaClicked = "loggedInHeroProductCtaClicked",
    loggedInHeroAnotherSiteCtaClicked = "loggedInHeroAnotherSiteCtaClicked"
}

export const loggedInHeroAnalyticsPayload = {
    eventType: "ui",
    action: "clicked",
    actionSubject: "button",
    actionSubjectId: "loggedInHero",
    source: "/software/jira"
};

export const loggedInHeroLoadedAnalyticsPayload = {
    eventType: "ui",
    action: "loaded",
    actionSubject: "ATLAS-53087",
    actionSubjectId: "loggedInHero",
    source: "/software/jira",
    attributes: {
        atlasId: "ATLAS-53087"
    }
};
